import { createAgencyStore } from '@price-pages-agency-cards/src/domain/store/agency.store';
import { useStore } from 'zustand';
let storeInstance = null;
export const initializeStore = (gateway) => {
    if (!storeInstance) {
        storeInstance = createAgencyStore(gateway);
    }
    return storeInstance;
};
const getStore = () => {
    if (!storeInstance) {
        throw new Error('Store not initialized. Call initializeStore first.');
    }
    return storeInstance;
};
export function useAgencyStore(selector) {
    const store = getStore();
    return useStore(store, selector);
}
